export const codeSuccess: number[] = [
  200, 201, 202, 203, 204, 205, 206, 207, 208, 226,
];

export enum axiosMethod {
  GET = "GET",
  POST = "POST",
  DELETE = "DELETE",
  PATCH = "PATCH",
  PUT = "PUT",
}

export enum EStatus {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}